import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import style from "./shopifySarkany.module.css";
import ShopifyItems from "./ShopifyItems/ShopifyItems";
import { getBatchShopifySarkanyus } from "../../../redux/actions/apiActions";
import { BounceLoader } from "react-spinners";
import Pagination from "../../../components/Paginate/paginate";

function ShopifySarkanyApi() {
  const dispatch = useDispatch();

  const { batchShopifySarkanyus, loading, paginate } = useSelector((state) => state.apiData);

  useEffect(() => {
    dispatch(getBatchShopifySarkanyus(1));
  }, [dispatch]);

      const handlePageChange = (page) => {
      dispatch(getBatchShopifySarkanyus(page)); 
    };

  return (
    <div className={loading ? style.shopifyApiContainerLoading : style.shopifyApiContainer}>
      {loading ? (
        <BounceLoader className={style.spinner} color="#61a030" />
      ) : (
        <>
          <div className={style.shopifyApiEncabezado}>
            <ul className={`${style.uLlist} nav row`}>
              {["Total Elementos", "Fecha de Inicio", "Fecha de fin", "Duración", "Estado", "Llamar ahora","Descargar CSV"].map((text, idx) => (
                <li key={idx} className="nav-item col">
                  <span className="nav-link">{text}</span>
                </li>
              ))}
            </ul>
          </div>
          <div>
            {batchShopifySarkanyus?.map((batch, idx) => (
              <ShopifyItems key={batch._id || idx} item={batch} />
            ))}
          </div>
        </>
      )}
          <div>
        <Pagination paginate={paginate} isLoading={loading} onPageChange={handlePageChange} />
      </div>
    </div>
  );
}

export default ShopifySarkanyApi;
